import { forNamespace, localizeCount } from 'common/lib/util/i18n';
import moment from 'moment';
import React from 'react';
import styles from './free-board-limit-info.less';

const format = forNamespace('free board limit board create info', {
  shouldEscapeStrings: false,
});

interface FreeBoardLimitInfoProps {
  isInline?: boolean;
  isAtOrOverLimit?: boolean;
  isLimitOverridden?: boolean;
  isDesktop?: boolean;
  isGracePeriod?: boolean;
  openBoardCount: number;
  orgName: string;
  upgradeUrl: string;
  gracePeriodEndDate?: Date;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  shouldShowFeedbackLink?: boolean;
}

const getText = ({
  isAtOrOverLimit,
  openBoardCount,
  orgName,
  upgradeUrl,
  isDesktop,
  isGracePeriod,
  gracePeriodEndDate,
  isLimitOverridden,
}: FreeBoardLimitInfoProps) => {
  // Warn about invalid states
  if (isGracePeriod && isDesktop && !isAtOrOverLimit) {
    console.error(
      'FreeBoardLimitInfo should not be rendered in Desktop during the grace period unless the free board limit is met/exceeded',
    );
  }

  if (isGracePeriod && !gracePeriodEndDate) {
    console.error(
      'isGracePeriod was passed to FreeBoardLimitInfoProps with no corresponding gracePeriodEndDate',
    );
  }

  // Localize the translations to be used within other translations (translaception)
  const openBoards = localizeCount('open-boards', openBoardCount);
  const upgradeLink = (
    <a key="upgrade-link" href={upgradeUrl}>
      {format('upgrade to business class', { orgName })}
    </a>
  );

  if (isGracePeriod && isLimitOverridden && !isDesktop && !isAtOrOverLimit) {
    return format('warn on web during grace period', {
      gracePeriodEndDate: moment(gracePeriodEndDate).format('LL'),
      upgradeLink,
    });
  }

  if (!isDesktop && !isAtOrOverLimit) {
    return format('warn on web', {
      openBoards,
      upgradeLink,
    });
  }

  if (!isDesktop && isAtOrOverLimit) {
    return format('block on web', {
      upgradeLink,
    });
  }

  if (isDesktop && !isAtOrOverLimit) {
    return format('warn on desktop', {
      orgName,
      openBoards,
    });
  }

  if (isDesktop && isAtOrOverLimit) {
    return format('block on desktop');
  }
};

const FreeBoardLimitInfo: React.FunctionComponent<FreeBoardLimitInfoProps> = ({
  onMouseEnter,
  onMouseLeave,
  isInline,
  shouldShowFeedbackLink,
  ...otherProps
}) => (
  <div
    className={isInline ? styles.purpleBox : styles.whiteBox}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <p>{getText(otherProps)}</p>
    {shouldShowFeedbackLink ? (
      <div className={styles.feedbackLinkContainer}>
        <a
          className={styles.feedbackLink}
          href="https://trello.typeform.com/to/FhilOt"
          target="_blank"
          rel="noopener noreferrer"
        >
          {format('feedback')}
        </a>
      </div>
    ) : null}
  </div>
);

export default FreeBoardLimitInfo;



// WEBPACK FOOTER //
// ./app/common/components/create-board/free-board-limit-info.tsx